<template>
  <a v-if="Object.keys(drawInfo).length > 0" class="lot-item">
    <div class="lot-item__top" @click="goToTrend(lotteryCode)">
      <div class="name">
        {{ lotteryName }}
        <span class="result">
          <p class="result-text">
            <span class="result-color" v-text="periodLabel"></span>期
          </p>
        </span>
      </div>
      <div class="result" style="align-self: flex-end;">
        <p class="result-text">距下期开奖:</p>
        <span style="color: red">{{ Timer }}</span>
      </div>
    </div>
    <div class="lot-item__center" @click="goToTrend(lotteryCode)">
      <div class="lot-item__center__lf">
        <div v-if="lotteryType === 'ssc' || lotteryType === '11x5' || lotteryType === 'kl10' || lotteryType === 'kl8'" class="multi-img-balls">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`ball-${index}`" class="balls">
              <span class="ball-color ball-blue">{{ ball }}</span>
            </div>
          </template>
        </div>
        <div v-if="lotteryCode === 'cqssc'" class="zodiac-img-balls">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`ball-${index}`" class="balls">
              <div class="balls__zodiac" :class="whichAnimal(ball)"></div>
            </div>
          </template>
        </div>
        <div v-if="lotteryCode === 'cqxync'" class="fruit-img-balls">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`ball-${index}`" class="balls">
              <div class="balls__fruit" :class="`fruit-${ball}`"></div>
            </div>
          </template>
        </div>
        <div v-if="lotteryType === 'pk10'" class="circl-ball">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`ball-${index}`" class="balls">
              <span v-if="ball === 10" class="ball-color" :class="`ball-${ball}`">{{ ball }}</span>
              <span v-else class="ball-color" :class="`ball-0${ball}`">{{ ball }}</span>
            </div>
          </template>
        </div>
        <div v-if="lotteryType === 'k3'" class="dice-ball">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`ball-${index}`" class="balls">
              <span class="ball-color" :class="`ball-0${ball}`">{{ ball }}</span>
            </div>
          </template>
        </div>
        <div v-if="lotteryType === 'xy28'" class="multi-img-balls">
          <div class="balls">
            <span class="ball-color ball-blue">{{ get(drawInfo, 'prePeriod.balls[0]', 0) }}</span>
          </div>
          <div class="balls bonus">
            <span class="ball-color ball-blue">{{ get(drawInfo, 'prePeriod.balls[1]', 0) }}</span>
          </div>
          <div class="balls bonus">
            <span class="ball-color ball-blue">{{ get(drawInfo, 'prePeriod.balls[2]', 0) }}</span>
          </div>
          <div class="balls equal">
            <span class="ball-color ball-red">{{ get(drawInfo, 'prePeriod.balls[0]', 0) + get(drawInfo, 'prePeriod.balls[1]', 0) + get(drawInfo, 'prePeriod.balls[2]', 0) }}</span>
          </div>
        </div>
        <div v-if="lotteryType === 'hk6'" class="multi-img-balls">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`balls-${index}`" class="balls" :class="{ bonus: index === 6 }">
              <lottery-ball :number="ball" />
              <p class="ball-text">
                {{ shengXiaoChinese(get(drawInfo, `prePeriod.ruleDetail.shengXiao[${index}]`, '')) }}/{{ wuXingChinese(get(drawInfo, `prePeriod.ruleDetail.wuXing[${index}]`, '')) }}
              </p>
            </div>
          </template>
        </div>
        <div v-if="lotteryType === 'others'" class="img_balls">
          <template v-for="(ball, index) in get(drawInfo, 'prePeriod.balls', [])">
            <div :key="`ball-${index}`" class="balls">
              <span class="ball-color ball-red">{{ ball }}</span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="lot-item__bottom">
      <div class="lot-item__bottom__lf">
        <div v-if="lotteryType === 'ssc' || lotteryType === '11x5' || lotteryCode === 'cqssc'" class="result">
          <p class="result-text" style="margin-right: 0.23rem;">{{ longHuMapping(get(drawInfo, 'prePeriod.ruleDetail.longHu', '')) }}</p>
          <p class="result-text" style="margin-right: 0.23rem;"> | </p>
          <p class="result-text">总和：</p>
          <p class="result-text">{{ getZongHe(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
          <p class="result-text">{{ getZongHeDaXiao(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
          <p class="result-text">{{ getZongHeDanShuang(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
        </div>
        <div v-if="lotteryType === 'pk10'" class="result">
          <template v-for="(longHu, index) in get(drawInfo, 'prePeriod.ruleDetail.zuLongHu', '')">
            <p :key="index" class="result-text" style="margin-right: 0.23rem;">{{ longHuMapping(longHu) }}</p>
          </template>
          <p class="result-text" style="margin-right: 0.23rem;"> | </p>
          <p class="result-text">冠亚和：</p>
          <p class="result-text">{{ get(drawInfo, 'prePeriod.ruleDetail.guanYaHe', '') }}</p>
          <p class="result-text">{{ getGuanYaHeDaXiao(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
          <p class="result-text">{{ getGuanYaHeDanShuang(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
        </div>
        <div v-if="lotteryType === 'kl10' || lotteryCode === 'cqxync'" class="result">
          <template v-for="(longHu, index) in get(drawInfo, 'prePeriod.ruleDetail.zuLongHu', '')">
            <p :key="index" class="result-text" style="margin-right: 0.23rem;">{{ longHuMapping(longHu) }}</p>
          </template>
          <p class="result-text" style="margin-right: 0.23rem;"> | </p>
          <p class="result-text">总和：</p>
          <p class="result-text">{{ getZongHe(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
          <p class="result-text">{{ getZongHeDaXiao(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
          <p class="result-text">{{ getZongHeDanShuang(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
        </div>
        <div v-if="lotteryType === 'k3' || lotteryType === 'kl8'" class="result">
          <p class="result-text">总和：</p>
          <p class="result-text">{{ getZongHe(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
          <p class="result-text">{{ getZongHeDaXiao(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
          <p class="result-text">{{ getZongHeDanShuang(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
        </div>
        <div v-if="lotteryType === 'xy28'" class="result">
          <p class="result-text">总和：</p>
          <p class="result-text">{{ getZongHeDanShuang(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
          <p class="result-text">{{ getZongHeDaXiao(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
        </div>
        <div v-if="lotteryType === 'hk6'" class="result">
          <p class="result-text">总分：</p>
          <p class="result-text">{{ getZongHe(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
        </div>
        <div v-if="lotteryType === 'others'" class="result">
          <p class="result-text">总和：</p>
          <p class="result-text">{{ getZongHe(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
          <p class="result-text" :class="{'hide': othersDaXiao}">{{ getZongHeDaXiao(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
          <p class="result-text">{{ getZongHeDanShuang(get(drawInfo, 'prePeriod.ruleDetail', {})) }}</p>
        </div>
      </div>
      <div v-if="routeName === 'm-lottery-trend-lottery_code'" class="trend-detail__status__rt" :class="{'hide': videoIsActive}">
        <div class="video" @click="openVideo">
          <img class="video__img" src="@/assets/style/img/combinedShape@2x.png" alt="">
          <p class="video__text">视频</p>
        </div>
      </div>
    </div>
    <video-popup :show.sync="showVideo" />
  </a>
</template>

<script>
import { ruleCodeMapping } from '@/utils/lotteryDictionary'
import { getDetailDrawInfo_mobile } from '@/api/mobile/basic'
import get from 'lodash.get'
import LotteryBall from '@/components/mobile/common/LotteryBall'
import * as moment from 'moment-mini'
import VideoPopup from '@/components/mobile/layout/VideoPopup'

export default {
  name: 'LotteryItem',
  components: {
    LotteryBall,
    VideoPopup
  },
  props: {
    lotteryCode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      drawInfo: {},
      routeName: this.$route.name,
      routeGroupId: this.$route.params.group_id || '',
      lotteryType: '',
      lotteryName: '',
      countDownTime: {
        timeoutID: 0,
        hr: 0,
        min: 0,
        sec: 0,
        status: 1,
        shotdown: false
      },
      videoIsActive: false,
      othersDaXiao: false,
      showVideo: false
    }
  },
  computed: {
    periodOnly() {
      switch (this.routeName.toLowerCase()) {
        case 'm-lottery-trend-lottery_code':
        case 'm-lmtj-lottery_code':
          return true
        default:
          return false
      }
    },
    Timer() {
      if (this.countDownTime.status && this.drawInfo.nextPeriod !== null) {
        this.$emit('timeChange', `${this.countDownTime.hr}:${this.countDownTime.min}:${this.countDownTime.sec}`)
        return `${this.countDownTime.hr}:${this.countDownTime.min}:${this.countDownTime.sec}`
      } else if (this.drawInfo.nextPeriod === null) {
        this.$emit('timeChange', '')
        return ''
      } else {
        this.$emit('timeChange', '开奖中...')
        return '开奖中...'
      }
    },
    periodLabel() {
      return get(this, 'drawInfo.prePeriod.period', '-')
    }
  },
  watch: {
    lotteryCode: {
      immediate: true,
      async handler(lotteryCode) {
        const [info, error] = await this.getDetailDrawInfo(lotteryCode)
        if (error) return
        this.drawInfo = info
        this.countDown()
      }
    }
  },
  async created() {
    await this.getLotteryType()
    this.codeMappingName()
    this.handleVideo()
    this.handleOthersDaXiao()
  },
  destroyed() {
    // 結束倒數
    clearTimeout(this.countDownTime.timeoutID)
    this.countDownTime.shotdown = true
  },
  methods: {
    goToTrend(lotteryCode) {
      this.$router.push(`/m/lottery/trend/${lotteryCode}`)
    },
    countDown() {
      if (!process.client) return
      if (this.countDownTime.shotdown) return

      if (this.drawInfo.nextPeriod === null) return
      const drawTime = this.drawInfo.nextPeriod.drawTime
      const end = moment(drawTime).valueOf(drawTime)
      const now = Date.parse(new Date())
      const msec = end - now

      const hr = Math.floor(msec / 1000 / 60 / 60)
      const min = Math.floor(msec / 1000 / 60 % 60)
      const sec = Math.floor(msec / 1000 % 60)

      this.countDownTime.hr = hr > 9 ? hr : '0' + hr
      this.countDownTime.min = min > 9 ? min : '0' + min
      this.countDownTime.sec = sec > 9 ? sec : '0' + sec

      if (msec < 1000) {
        this.countDownTime.status = 0
        this.timeStopGetNewData()

        this.$emit('drawing', true)
        return
      }

      this.countDownTime.timeoutID = window.setTimeout(() => {
        this.countDown()
      }, 1000)
    },
    async timeStopGetNewData() {
      const [drawInfo, error] = await getDetailDrawInfo_mobile(this.lotteryCode)
      if (error) {
        setTimeout(() => {
          this.timeStopGetNewData()
        }, 2000)
      }

      if (!this.drawInfo.prePeriod) {
        console.warn('LotteryItem timeStopGetNewData: 缺少drawInfo.prePeriod!', this.drawInfo.prePeriod)
        return
      }
      const previousPrePeriod = get(this.drawInfo, 'prePeriod.period')
      const currentPrePeriod = get(drawInfo[this.lotteryCode], 'prePeriod.period')

      if (previousPrePeriod === currentPrePeriod) {
        setTimeout(() => {
          this.timeStopGetNewData()
        }, 2000)
      } else {
        this.drawInfo = drawInfo[this.lotteryCode]
        this.countDownTime.status = 1
        this.countDown()

        this.$emit('complete', this.drawInfo)
      }
    },
    async codeMappingName() {
      const [lotteryNameMapping, error] = await this.$store.dispatch('lottery/getLotteryNameMapping')
      if (error) {
        console.warn('取得lotteryNameMapping 失敗!', error)
        return
      }

      this.lotteryName = lotteryNameMapping[this.lotteryCode]
    },
    async getLotteryType(code) {
      if (this.lotteryCode === 'cqssc' || this.lotteryCode === 'cqxync') return
      this.lotteryType = await this.$getLotteryType(this.lotteryCode)
    },
    shengXiaoChinese(animal) {
      return ruleCodeMapping[animal]
    },
    wuXingChinese(wuXing) {
      return ruleCodeMapping[wuXing]
    },
    longHuMapping(longHu) {
      return ruleCodeMapping[longHu]
    },
    getZongHe(zongHe) {
      return get(zongHe, 'zongHe[0]', '')
    },
    getZongHeDaXiao(zongHeDaXiao) {
      const result = get(zongHeDaXiao, 'zongHeDaXiao[0]', '')
      return ruleCodeMapping[result]
    },
    getGuanYaHeDaXiao(guanYaHeDaXiao) {
      const result = get(guanYaHeDaXiao, 'guanYaHeDaXiao[0]', '')
      return ruleCodeMapping[result]
    },
    getZongHeDanShuang(zongHeDanShuang) {
      const result = get(zongHeDanShuang, 'zongHeDanShuang[0]', '')
      return ruleCodeMapping[result]
    },
    getGuanYaHeDanShuang(guanYaHeDanShuang) {
      const result = get(guanYaHeDanShuang, 'guanYaHeDanShuang[0]', '')
      return ruleCodeMapping[result]
    },
    whichAnimal(ball) {
      switch (ball) {
        case 0:
          return 'rat'
        case 1:
          return 'tiger'
        case 2:
          return 'rabbit'
        case 3:
          return 'dragon'
        case 4:
          return 'snake'
        case 5:
          return 'horse'
        case 6:
          return 'sheep'
        case 7:
          return 'monkey'
        case 8:
          return 'chicken'
        case 9:
          return 'pig'
        default:
          console.warn('LotteryItem: whichAnimal: 對應失敗!', ball)
      }
    },
    handleVideo() {
      if (this.routeName !== 'm-lottery-trend-lottery_code') return
      if (this.lotteryType === 'others') {
        if (this.lotteryCode === 'fc3d' || this.lotteryCode === 'pl3' || this.lotteryCode === 'shssc') {
          this.videoIsActive = false
        } else {
          this.videoIsActive = true
        }
      } else if (this.lotteryType === 'hk6') {
        this.videoIsActive = true
      }
    },
    handleOthersDaXiao() {
      if (this.lotteryType === 'others') {
        if (this.lotteryCode === 'fc3d' || this.lotteryCode === 'pl3' || this.lotteryCode === 'shssc') {
          this.othersDaXiao = false
        } else {
          this.othersDaXiao = true
        }
      }
    },
    async getDetailDrawInfo(lotteryCode) {
      const [drawInfo, error] = await getDetailDrawInfo_mobile(lotteryCode)
      if (error) return [null, error]
      this.codeMappingName()
      this.$emit('complete', drawInfo[lotteryCode])
      return [drawInfo[lotteryCode], null]
    },
    openVideo() {
      this.showVideo = true
    },
    get(obj = {}, query = '', defaultValue = '') {
      return get(obj, query, defaultValue)
    }
  }
}
</script>

<style scoped>
  .video {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    background-color: #178aff;
    border-radius: 6px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    width: 61px;
    height: 27px;
    margin-left: auto;
  }
  .video__img {
    height: 18px;
    vertical-align: middle;
  }
  .video__text {
    margin: 0;
    font-size: 14px;
    padding-left: 4px;
    color: white;
  }
  .hide {
    display: none;
  }
  .lot-item__bottom {
    z-index:5;
  }
  .lot-item__bottom__lf {
    width: 100%;
  }
  .lot-item__bottom__lf .result {
    width: 100%;
  }
</style>
